import React, { useEffect, useState } from "react";
import { Form, Spin, Modal, Input } from "antd";
import Utils from "../../../../../shared/helpers/utils";
import { FormConfig } from "../../../../../shared/config/GlobalConfig";
import CuitFormItem from '../../../../../shared/components/cuitFormItem';
import CampoObligatorio from "../../../../../shared/components/campoObligatorio";

const FormItem = Form.Item;

const AnexoVProveedorModal = props => {
  const [working, setWorking] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    
  }, []);

  useEffect(() => {
    if(props.visible === true){ form.resetFields(); }
  }, [props.visible]);

  const handleOk = () => {
    form.validateFields()
      .then(values => {
        props.onOk({ 
          Hash: props.proveedor ? props.proveedor.Hash : Utils.generateHash(), 
          ...values 
        });
      });
  }

  return (
    <Modal  
      title={`${props.proveedor ? 'Editar' : 'Agregar'} Proveedor`}
      width="60%"
      visible={ props.visible }
      onOk={ handleOk }
      onCancel={ props.onCancel }
    >
      <Spin spinning={ working }>
        <Form
          { ...FormConfig.DefaultLayout }
          form={ form }
          name="formulario"
          initialValues={{ ...props.proveedor,
            IdSustanciaDeclarada: props.proveedor?.IdSustanciaDeclarada ? props.proveedor.IdSustanciaDeclarada : props.sustancia?.IdSustanciaDeclarada,
          }}
          scrollToFirstError
        >
          { props.proveedor?.IdProveedor ? <FormItem name="IdProveedor" label="Proveedor" rules={ FormConfig.DefaultRules }>
            <Input disabled/>
          </FormItem> : '' }

          { props.sustancia?.IdSustanciaDeclarada ? <FormItem name="IdSustanciaDeclarada" label="Sustancia Declarada" rules={ FormConfig.DefaultRules }>
            <Input disabled/>
          </FormItem> : '' }

          <CuitFormItem name="Cuit" label="Cuit" rules={ [...FormConfig.DefaultRules] } />

          <FormItem name="NombreComercial" label="Nombre Comercial" rules={ FormConfig.DefaultRules }>
            <Input />
          </FormItem>

          <CampoObligatorio/>
          
        </Form>
      </Spin>
    </Modal>
  );
}

export default AnexoVProveedorModal;